/** @format */
import styled, { css } from 'styled-components';

import { smallTablet } from '@toucan/client/global/application';

// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component -- Legacy code: do not use as an example.
/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component -- Legacy code: do not use as an example.
export const StyledPaginationControls = styled.div`
    grid-area: pagination-controls;
    display: flex;
    justify-content: flex-start;
    font-size: 1.2rem;

    .results-meta {
        display: flex;
        align-items: center;

        > span {
            margin-right: var(--layout-spacing-12);
        }

        > button {
            margin-right: var(--layout-spacing-24);
        }
    }

    ${smallTablet(css`
        display: none;
    `)}
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
